/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c25aefba3f565389be591ab3810a8b4854ccea56";
